<div class="content-container mb-3">
  <div class="title">
    @if (displayDate) {
    <mwp-text-translate text="Select a Date" jsonKey="selectDate" />
    }
    @if (displayBenefitCatgory) {
    <mwp-text-translate text="Select a Benefit Catgory" jsonKey="selectBenefitCatgory" />
    }
    @if (displayOpenEnrollment) {
    <mwp-text-translate text="Select a Open Enrollment" jsonKey="selectOpenEnrollment" />
    }
  </div>
  <div class="content">
    <form [formGroup]="parameterForm" class="mb-3">
      @if (displayBenefitCatgory || displayOpenEnrollment) {
      <div>
        <mwp-table-formarray [form]="parameterForm" [arrayName]="openEnrollmentFormArrayName" [tableColumns]="reportColumns" [dataSource]="reportMatTableData"></mwp-table-formarray>
      </div>
      }
      @if (displayDate) {
      <div class="col-3">
        <mwp-datepicker [form]="parameterForm" [nameForControl]="dateWizardValue" />
      </div>
      }
    </form>
  </div>
  <div class="footer d-inline-flex justify-content-end w-100">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    @if (parameterForm) {
    <button class="mwp-button ms-3" [disabled]="!parameterForm.valid" (click)="save()">
      <mwp-text-translate text="Continue" jsonKey="continue" />
    </button>
    }
  </div>
</div>